import { ConfigProvider, Drawer } from 'antd';
import styled from 'styled-components';
import { Button, Colors, Row, Text } from 'basic-ui-lib';
import { RadioButtons } from 'basic-ui-lib/components/RadioButtons';
import storeSelectors from 'modules/store/services/selectors';

interface Props {
  open: boolean;
  value?: string;
  onChange?: (value: string) => void;
  onClose?: () => void;
}

const TimezonePicker = ({ open, value, onChange, onClose }: Props) => {
  const timezones = storeSelectors.getTimezones();
  const timezoneOptions = timezones.map((tz) => ({
    value: tz.value,
    label: tz.name,
  }));

  const handleChoose = () => {
    onClose?.();
  };

  return (
    <ConfigProvider>
      <StyledDrawer
        title={
          <Row flex={1} justifyContent='center' alignItems='center'>
            <Text title_h6 semibold center>
              Timezone
            </Text>
          </Row>
        }
        placement='bottom'
        closable={false}
        onClose={onClose}
        open={open}
        height='80%'
        footer={
          <Row>
            <Button type_cancel lg onClick={onClose} style={{ width: '100%' }}>
              Close
            </Button>
            <Button type_second lg style={{ width: '100%' }} onClick={handleChoose}>
              OK
            </Button>
          </Row>
        }
        destroyOnClose
        style={{ borderRadius: '10px 10px 0px 0px' }}
      >
        <RadioButtons options={timezoneOptions} value={value} onChange={onChange} className='radio-styled' />
      </StyledDrawer>
    </ConfigProvider>
  );
};

TimezonePicker.displayName = 'TimezonePicker';
export default TimezonePicker;

const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: 16px 16px 32px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    background-color: ${Colors.neutral.bg[2]};
  }

  .ant-drawer-footer {
    padding: 16px 16px;
    box-shadow: 0px -4px 8px 0px #0000001a;
    background-color: ${Colors.neutral.bg[1]};
  }

  .radio-styled {
    display: grid;
    grid-template-columns: 1fr;
    row-gap: 16px;

    .custom-text {
      font-size: 14px;
      display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        white-space: normal;
        text-overflow: ellipsis;
        text-align: left;
    }
  }
`;
